import type { BuildDeviceBoxLookup, PlanRect } from "./types";

// PDF points: the half-size of a device whose symbol box is unknown, and how far a box centre may sit from it.
const FALLBACK_HALF_SIZE = 7;
const MATCH_MAX_DISTANCE = 40;

const squareAround = ({ x, y }: { x: number; y: number }): PlanRect => ({
  x1: x - FALLBACK_HALF_SIZE,
  y1: y - FALLBACK_HALF_SIZE,
  x2: x + FALLBACK_HALF_SIZE,
  y2: y + FALLBACK_HALF_SIZE,
});

export const buildDeviceBoxLookup: BuildDeviceBoxLookup = (elementBoxes) => {
  const byId = new Map(elementBoxes.map((element) => [element.id, element.bbox]));
  const centres = elementBoxes.map((element) => ({
    bbox: element.bbox,
    x: (element.bbox.x1 + element.bbox.x2) / 2,
    y: (element.bbox.y1 + element.bbox.y2) / 2,
  }));
  return (elementId, position) => {
    const exact = elementId ? byId.get(elementId) : undefined;
    if (exact) return exact;
    let best: PlanRect | null = null;
    let bestDistance = MATCH_MAX_DISTANCE * MATCH_MAX_DISTANCE;
    centres.forEach((centre) => {
      const distance = (centre.x - position.x) ** 2 + (centre.y - position.y) ** 2;
      if (distance <= bestDistance) {
        bestDistance = distance;
        best = centre.bbox;
      }
    });
    return best ?? squareAround(position);
  };
};
